import {UPDATE_LAST_RECALC} from './actions';

export function lastRecalcDateTime(
  state: LastRecalcDateTimeState,
  {type, payload}: Action
): LastRecalcDateTimeState {
  switch (type) {
    case UPDATE_LAST_RECALC:
      return payload as LastRecalcDateTimeState;

    default:
      return state;
  }
}
